export const Required = (value): undefined | string => (value ? undefined : 'Required');
